export default __webpack_public_path__ + "static/media/towerstack.51846c94.mp4";